export default __webpack_public_path__ + "static/media/home.4a4a7377.svg";